import React from 'react';
import { Box } from '@mui/material';

export type PillTone = 'success' | 'info' | 'warning' | 'error' | 'neutral' | 'accent';

// Cores explícitas: os Chips do tema ficavam ilegíveis (label branco / bloco escuro) no painel.
const TONES: Record<PillTone, { bg: string; fg: string }> = {
  success: { bg: 'rgba(16, 185, 129, 0.12)', fg: '#047857' },
  info: { bg: 'rgba(62, 84, 181, 0.1)', fg: '#2e3f8a' },
  warning: { bg: 'rgba(245, 158, 11, 0.15)', fg: '#a35a00' },
  error: { bg: 'rgba(239, 68, 68, 0.12)', fg: '#b91c1c' },
  neutral: { bg: 'rgba(82, 86, 99, 0.1)', fg: '#3a3d47' },
  accent: { bg: 'rgba(247, 66, 17, 0.1)', fg: '#d4380d' },
};

interface StatusPillProps {
  label: React.ReactNode;
  tone?: PillTone;
}

const StatusPill: React.FC<StatusPillProps> = ({ label, tone = 'neutral' }) => {
  const c = TONES[tone];
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1.25,
        py: 0.25,
        borderRadius: '999px',
        bgcolor: c.bg,
        color: c.fg,
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 1.6,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Box>
  );
};

export default StatusPill;
